import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { SubType } from '@shared/constants';
import { WinCard, WinCardDynamicComponent } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';
import { Variant3Component } from './variant3/variant3.component';
import { Variant4Component } from './variant4/variant4.component';
import { Variant5Component } from './variant5/variant5.component';
import { Variant6Component } from './variant6/variant6.component';
import { Variant7Component } from './variant7/variant7.component';
import { Variant8Component } from './variant8/variant8.component';
import { Variant9Component } from './variant9/variant9.component';
import { Variant10Component } from './variant10/variant10.component';

@Component({
  selector: 'b2c-win-card',
  imports: [NgComponentOutlet],
  templateUrl: './win-card.component.html',
})
export class WinCardComponent extends BaseComponent {
  amount = input.required<number>();
  subType = input<SubType>(SubType.DEFAULT);

  protected config: WinCard =
    this.loyaltyChallengeConfig.components.challenges.elements.winCard;

  public components: Signal<WinCardDynamicComponent<WinCard>> = computed(() => {
    const config = this.config;
    // Only the 4th and 10th variants render a sub type specific design
    const subTypeInputs = {
      config,
      amount: this.amount(),
      subType: this.subType(),
    };
    return {
      [this.Variants.VARIANT_1]: {
        component: Variant1Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_2]: {
        component: Variant2Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_3]: {
        component: Variant3Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_4]: {
        component: Variant4Component,
        inputs: subTypeInputs,
      },
      [this.Variants.VARIANT_5]: {
        component: Variant5Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_6]: {
        component: Variant6Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_7]: {
        component: Variant7Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_8]: {
        component: Variant8Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_9]: {
        component: Variant9Component,
        inputs: { config, amount: this.amount() },
      },
      [this.Variants.VARIANT_10]: {
        component: Variant10Component,
        inputs: subTypeInputs,
      },
    };
  });
}
